export default __webpack_public_path__ + "static/media/ErrorIcon.b868684e.svg";